import React from 'react';
import { IconProps } from '.';

type RemoveIconProps = {} & IconProps;

export const RemoveIcon: React.FC<RemoveIconProps> = ({
  height = 24,
  width = 24,
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      fill="none"
      viewBox="0 0 18 18"
    >
      <circle cx="9" cy="9" r="9" fill="#D0D0D0"></circle>
      <path stroke="#fff" d="M6 12l6-6M12 12L6 6"></path>
    </svg>
  );
};
